import * as React from 'react';
import styled, {css} from 'styled-components'
import {
    ConstBreakPoint,
    ConstColor,
    ConstFontStyle,
    ConstFontWeight,
    ConstMargin
} from "../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement> {
    icon?: string;
    iconPrefix?: "900" | "400" | "300"; // fontawesom solid 900 regular 400 light 300
    bold?: boolean;
    defaultMargin?: boolean;
}

const ParagraphSupDefault: React.FC<IProps> = (props) => {

    const { icon, bold, defaultMargin, iconPrefix, children, ...PProps } = props;

    return<p {...PProps}>{children}</p>;

};

const ParagraphSup = styled(ParagraphSupDefault)`
    color: ${ConstColor.Base};
    font-style: normal;
    font-weight: ${props => props.bold ? ConstFontWeight.BOLD : ConstFontStyle.SpParagraphSup.fontWeight};
    font-size: ${ConstFontStyle.SpParagraphSup.fontSize};
    line-height: ${ConstFontStyle.SpParagraphSup.lineHeight};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
    font-weight: ${props => props.bold ? ConstFontWeight.BOLD : ConstFontStyle.ParagraphSup.fontWeight};
        font-size: ${ConstFontStyle.ParagraphSup.fontSize};
        line-height: ${ConstFontStyle.ParagraphSup.lineHeight};
    }
    
    & > em {
        font-style: inherit;
        font-weight: ${ConstFontWeight.BOLD};
        background: ${ConstColor.TableTh};
        padding: 0 5px;
    }
    
    ${props => props.defaultMargin && css`
        margin-bottom: ${ConstMargin.SpParagraphSupBottom};
        @media screen and (min-width: ${ConstBreakPoint.Default}) {
            margin-bottom: ${ConstMargin.ParagraphSupBottom};
        }
    `}    
    ${props => props.icon && css`
        ::before {
            margin-right: ${ConstMargin.ParagraphIconRight};
            content: ${props.icon};
            font-family: "Font Awesome 5 Free";
            font-weight: ${props.iconPrefix ? props.iconPrefix : "900"};
        }
    `}
`;

export default ParagraphSup;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/text/paragraph_sup.tsx